export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  videoCount: number;
  thumbnail: string;
}

export const categories: Category[] = [
  {
    id: 'cat-01',
    name: '纪录片',
    slug: 'documentary',
    icon: 'ri-film-line',
    description: '精选全球顶级纪录片，涵盖自然、历史、人文等多个领域',
    videoCount: 1280,
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20filmmaking%20scene%20with%20professional%20camera%20in%20nature%2C%20wildlife%20in%20background%2C%20golden%20hour%20lighting%2C%20cinematic%20mood%2C%20warm%20earth%20tones&width=400&height=240&seq=mogu-cat-doc&orientation=landscape',
  },
  {
    id: 'cat-02',
    name: '科技',
    slug: 'technology',
    icon: 'ri-cpu-line',
    description: '前沿科技资讯、数码评测、AI发展动态一网打尽',
    videoCount: 3560,
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20concept%20with%20circuit%20board%20patterns%20and%20digital%20elements%2C%20clean%20modern%20aesthetic%2C%20warm%20metallic%20accents%2C%20minimalist%20tech%20design&width=400&height=240&seq=mogu-cat-tech&orientation=landscape',
  },
  {
    id: 'cat-03',
    name: '影视',
    slug: 'entertainment',
    icon: 'ri-movie-2-line',
    description: '热门影视剧、经典电影解析、独家影评推荐',
    videoCount: 4520,
    thumbnail: 'https://readdy.ai/api/search-image?query=Vintage%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20warm%20lighting%2C%20classic%20cinema%20atmosphere%2C%20golden%20age%20hollywood%20aesthetic%2C%20nostalgic%20charm&width=400&height=240&seq=mogu-cat-film&orientation=landscape',
  },
  {
    id: 'cat-04',
    name: '教育',
    slug: 'education',
    icon: 'ri-book-open-line',
    description: '从编程到外语，从数学到艺术，海量优质课程助你成长',
    videoCount: 2890,
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20library%20with%20sunlit%20reading%20area%20and%20wooden%20bookshelves%2C%20warm%20learning%20environment%2C%20knowledge%20and%20education%20theme%2C%20peaceful%20atmosphere&width=400&height=240&seq=mogu-cat-edu&orientation=landscape',
  },
  {
    id: 'cat-05',
    name: '美食',
    slug: 'food',
    icon: 'ri-restaurant-line',
    description: '世界美食探索、烹饪教程、饮食文化深度解读',
    videoCount: 1890,
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20food%20photography%20with%20fresh%20ingredients%20on%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20culinary%20arts%20aesthetic%2C%20rich%20textures%20and%20colors&width=400&height=240&seq=mogu-cat-food&orientation=landscape',
  },
  {
    id: 'cat-06',
    name: '旅游',
    slug: 'travel',
    icon: 'ri-earth-line',
    description: '全球旅游攻略、城市探索、户外冒险精彩呈现',
    videoCount: 2150,
    thumbnail: 'https://readdy.ai/api/search-image?query=Scenic%20travel%20destination%20with%20mountain%20lake%20reflection%20and%20colorful%20backpack%2C%20warm%20sunset%20lighting%2C%20adventure%20wanderlust%20theme%2C%20breathtaking%20landscape&width=400&height=240&seq=mogu-cat-travel&orientation=landscape',
  },
  {
    id: 'cat-07',
    name: '音乐',
    slug: 'music',
    icon: 'ri-music-line',
    description: '音乐教学、乐器演奏、演唱会现场、音乐人专访',
    videoCount: 1680,
    thumbnail: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20colorful%20lights%20and%20musical%20instruments%2C%20live%20music%20performance%20atmosphere%2C%20warm%20spotlight%20effect%2C%20dynamic%20energy&width=400&height=240&seq=mogu-cat-music&orientation=landscape',
  },
  {
    id: 'cat-08',
    name: '体育',
    slug: 'sports',
    icon: 'ri-basketball-line',
    description: '体育赛事集锦、健身教程、运动技巧全面覆盖',
    videoCount: 2340,
    thumbnail: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20at%20sunset%20with%20athletes%20in%20action%2C%20dynamic%20sports%20photography%2C%20warm%20golden%20light%2C%20energy%20and%20movement&width=400&height=240&seq=mogu-cat-sport&orientation=landscape',
  },
  {
    id: 'cat-09',
    name: '汽车',
    slug: 'automotive',
    icon: 'ri-car-line',
    description: '新车评测、汽车文化、改装案例、赛车赛事',
    videoCount: 1120,
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20car%20on%20scenic%20coastal%20road%20during%20sunset%2C%20automotive%20lifestyle%20photography%2C%20warm%20golden%20hour%20light%2C%20elegant%20design&width=400&height=240&seq=mogu-cat-auto&orientation=landscape',
  },
];